<template>
  <div
    v-if="auditedAction"
    class="audit-bottom-panel float-component px-0 pt-2 pb-1"
  >
    <div class="d-flex justify-content-between align-items-center px-2">
      <div class="d-flex align-items-center">
        <span class="ap-title ap-title__section">
          <i
            v-tooltip="auditedAction.entityActionType.name"
            class="far ml-3 mr-2"
            :class="actionTypeIcon"
            aria-hidden="true"
          />
          {{ auditedAction.entityType.name }} {{ auditedAction.entityLabel }}</span>
      </div>
      <div class="d-flex align-items-center">
        <b-button
          v-shortkey="['shift', 'esc']"
          class="btn__icon btn__icon--primary secondary px-4"
          @click="closeBottomPanel"
          @shortkey.prevent="closeBottomPanel"
        >
          <i
            class="far fa-times"
            aria-hidden="true"
          />
        </b-button>
      </div>
    </div>
    <div class="flex-grow-1">
      <vt-grid
        :key="auditedAction.id"
        :row-data="auditedAction.fieldsWithOriginalAndUpdatedValues"
        :grid-options="gridOptions"
        class="audit-detail-grid"
        :column-defs="columnDefs"
      />
    </div>
  </div>
</template>

<script>
import VtGrid from '@/components/VtGrid/VtGrid'
import { auditBottomPanelGridColumnDefs } from '@/modules/auditModule/views/components/audit-bottom-panel/audit-bottom-panel-grid.column-defs'
import auditedActionService, { AUDITED_ACTION_TYPES, getIconFromActionType } from '@/modules/auditModule/services/AuditedActionService'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

export default {
    name: 'AuditBottomPanel',
    components: {
        VtGrid
    },
    props: {
        auditedActionId: { type: Number, required: true }
    },
    data() {
        return {
            auditedAction: null,
            columnDefs: null
        }
    },
    computed: {
        gridOptions() {
            return {
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                getRowHeight: ({ data }) => {
                    if ((data.originalValue && data.originalValue.includes('<', '>')) || (data.updatedValue && data.updatedValue.includes('<', '>'))) {
                        // 3 lines row
                        return 90
                    } else {
                        // 1 line row
                        return 30
                    }
                }
            }
        },
        actionTypeIcon() {
            return this.auditedAction ? getIconFromActionType(this.auditedAction.entityActionType.id) : ''
        }
    },
    watch: {
        auditedActionId(newValue) {
            if (!newValue) {
                this.auditedAction = null
            } else {
                this.$nextTick(() => this.loadAuditedAction())
            }
        }
    },
    mounted() {
        this.loadAuditedAction()
    },
    methods: {
        closeBottomPanel() {
            this.$emit('closeBottomPanel')
        },
        async loadAuditedAction() {
            const response =
                await this.$_toCallSecure(
                    auditedActionService.findById(this.auditedActionId))
            if (response) {
                this.auditedAction = response
                this.columnDefs = auditBottomPanelGridColumnDefs(!this._isUpdateActionType())
            }
        },
        _isUpdateActionType() {
            return (!this.auditedAction.subentityActionType && this.auditedAction.entityActionType.id === AUDITED_ACTION_TYPES.UPDATE.id) ||
          (this.auditedAction.subentityActionType && this.auditedAction.subentityActionType.id === AUDITED_ACTION_TYPES.UPDATE.id)
        }
    }
}
</script>

<style lang="scss">

.audit-bottom-panel .header-subtitle{
  font-size: 0.8rem;
  text-transform: uppercase;
}

.audit-bottom-panel{
    box-shadow: 0 1px 3px 0 rgba(48, 49, 51, 0.1);
    height: 300px;
    margin-bottom: $footer-height;
    display: flex;
    flex-direction: column;
}

</style>
